import { GRAPHQL_AUTH_MODE, GraphQLQuery } from "@aws-amplify/api"
import { SubmitImageGenerationFeedbackQuery, SubmitImageGenerationFeedbackQueryVariables } from "../../API";
import * as queries from "../../graphql/queries";
import { API } from "aws-amplify"

export const submitImageGenerationFeedback = async (partitionKey: string, sortKey: string, feedbackRating: number, feedbackText: string) => {
    const response = await API.graphql<GraphQLQuery<SubmitImageGenerationFeedbackQuery>>({
        query: queries.submitImageGenerationFeedback,
        variables: {
            partitionKey: partitionKey,
            sortKey: sortKey,
            feedbackRating: feedbackRating,
            feedbackText: feedbackText
        } as SubmitImageGenerationFeedbackQueryVariables,
        authMode: GRAPHQL_AUTH_MODE.AMAZON_COGNITO_USER_POOLS
    })
    let parsedResults = JSON.parse(response.data?.submitImageGenerationFeedback || "{}");
    return parsedResults
}